import { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { FONT } from "../../../value/staticValues";
import { percentValue } from "../../../common/util";

import DashboardBox from "../../base/tamplate/DashboardBox";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';

interface BarChartBoxProps {
    navigate: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    color: string;
    secondcolor: string;
}

export default function BarChartBox(props:BarChartBoxProps) {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        setPercent(props.data/props.total);
    }, [props]);
    
    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
        }}>
            <View style={{flexDirection: "row", alignItems: "center", height: 20}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 13,
                    color: "#262626"
                }}>
                    {props.title}
                </Text>
                {props.url ?
                    <MoreImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {props.navigate(`${props.url}`)}}
                    />
                :null }
            </View>

            <View style={{flexDirection: "row", marginTop: 20, height: "85%"}}>
                <View>
                    <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                        <Text style={{
                            fontFamily: FONT.BOLD,
                            fontSize: 32,
                            color: "#333333"
                        }}>
                            {props.data}
                        </Text>
                        <Text style={{
                            marginLeft: 3, marginBottom: 8,
                            fontFamily: FONT.REGULAR,
                            fontSize: 12,
                            color: "#8c8c8c"
                        }}>
                            Available
                        </Text>
                    </View>
                    <View style={{marginTop: "auto"}}>
                        <Text style={{
                            fontFamily: FONT.MEDIUM,
                            fontSize: 14,
                            lineHeight: 12,
                            color: "#0853fb" 
                        }}>
                            {props.data} Used
                        </Text>
                        <Text style={{
                            marginTop: 10,
                            fontFamily: FONT.REGULAR,
                            fontSize: 12,
                            color: "#8c8c8c",
                        }}>
                            Total {props.total}
                        </Text>
                    </View>
                </View>
                <View style={{
                    flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-end",
                    marginLeft: "auto", marginTop: "auto", marginRight: 20
                }}>
                    <Text style={{
                        marginRight: 14,
                        fontFamily: FONT.REGULAR,
                        fontSize: 10,
                        color: "#808080"
                    }}>
                        Max
                    </Text>
                    <View style={{alignItems: "flex-end", marginTop: 7}}>
                        <View style={{...styles.barChartContainer, height: 200}}>
                            <View style={styles.MaxLine}/>
                            <div style={barStyle}/>
                            <View style={styles.MaxLine}/>
                        </View>
                        <View style={{...styles.barChartContainer, height: 200 * percent, marginTop: -(200 * percent)}}>
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <View style={{...styles.CirclePoint, backgroundColor: props.secondcolor}}/>
                                <View style={{...styles.MaxLine, width: 80, borderColor: props.secondcolor}}/>
                            </View>
                            <div style={{...barStyle, backgroundImage: "linear-gradient(to bottom, " + props.secondcolor + ", " + props.color + " 70%)"}}/>
                        </View>
                    </View>
                </View>
            </View>
            
        </DashboardBox>
    )
}

const barStyle ={
    width: "100%", height: "100%",
    backgroundColor: "#f5f8fa",
}

const styles = StyleSheet.create({
    barChartContainer: {
        width: 80,
        alignItems: "flex-end"
    },
    BarChart: {
        width: "100%", height: "100%",
        backgroundColor: "#f5f8fa",
    },
    MaxLine: {
        borderTopWidth: 1, borderColor: "#e3e1ea",
        width: 90
    },
    CirclePoint:{ 
        position: "absolute", left: -8,
        width: 8, height: 8,
        borderRadius: 8,
        backgroundColor: "#3059fa",
        boxShadow: "0 2px 4px 0 rgba(48, 89, 250, 0.5)",
    }
})